import { STRIPE_ENTITY_CONFIGURATION } from 'src/constants/subscription'

export const stripe = Stripe(STRIPE_ENTITY_CONFIGURATION.STRIPE_KEY)
